import type { SortDirection } from './types';

export const ASC: SortDirection = 'ascending';
export const DESC: SortDirection = 'descending';
